<template>
  <div >

    <table class="tb">
      <tr >
        <th width="150px" >功能</th>
        <th width="400px">启用状态</th>
        <th>功能说明</th>
      </tr>
      <tr>
        <td>自动备注</td>
        <td >
          <el-radio-group v-model="autoRate.memo">
            <el-radio :label="1">开启自动备注</el-radio>
            <el-radio :label="0">关闭自动备注</el-radio>
          </el-radio-group >
        </td>
        <td><span>开启自动备注</span></td>
      </tr>
      <tr>
        <td>备注内容</td>
        <td  style="text-align: center"><el-input v-model="autoRate.sellerMemo" type="text"  ></el-input></td>
        <td><span>设定自动备注内容</span></td>
      </tr>
      <tr>
        <td>备注旗帜颜色</td>
        <td  style="text-align: left">
          <el-select v-model="autoRate.sellerFlag" size="mini"  collapse-tags style="width: 150px" placeholder="请选择">
            <el-option
              v-for="item in flagOpto"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </td>
        <td><span>设定自动备注旗帜颜色</span></td>
      </tr>
      <tr>
        <td>延时备注时间</td>
        <td  style="text-align: center"><el-input v-model="autoRate.delay" type="text"  ></el-input></td>
        <td>付款后等待多长时间再备注，单位秒，0 表示不延时
        </td>
      </tr>
      <tr>
        <td>自动备注商品ID</td>
        <td  style="text-align: center"><el-input v-model="autoRate.memoId" type="textarea" :rows="5" ></el-input></td>
        <td><span>需要自动备注的商品ID(用逗号分隔)，例如：31415926, 31415927</span></td>
      </tr>
    </table>
    <div class="btndiv">
      <el-button  type="primary" @click="saveRate">保存自动备注设置</el-button>
    </div>
  </div>
</template>

<script>
import $api from "../api/axios";
import storage from "../api/storage"

export default {
  name: "AutoMmeo",
  data(){
    return {
      autoRate: {
        nick: '',
        sessionkey: '',
        createTime: '',
        deadLine: '',
        valid: 0,
        send: 0,
        virtual:'0',
        memo: 0,
        sellerMemo:'',
        sellerFlag: 2,
        delay: 0,
        rateType: 0,
        attack: 0,
        rateAttack: '',
        rateBlack: '',
        blackId:'',
        memoId: '',
        rateMoban: [{content: '好评'}, {content: '还是好评'}],

      },
      version: 0,
      buyers:'',
      openIds:'',
      flagOpto:[{value:0,label:'灰'},{value:1,label:'红'},{value:2,label:'黄'},{value:3,label:'绿'},{value:4,label:'蓝'},{value:5,label:'紫'},
        {value:6,label:'橙色'},{value:7,label:'浅蓝'},{value:8,label:'浅粉'},{value:9,label:'深绿'},{value:10,label:'桃红'}],
    }

  },
  methods:{
    saveRate(){
      let curver = parseInt(this.version);
      if(this.autoRate.memo === 1) {
        if (curver <= 2) {
          this.$message.error('该版本不支持此功能，请升级版本');
          return;
        }
      }
      let param = {
        nick: storage.get("nick"),
        sessionkey: "",
        createTime: this.autoRate.createTime,
        deadLine: this.autoRate.deadLine,
        valid: this.autoRate.valid,
        send: this.autoRate.send,
        virtual: this.autoRate.virtual,
        memo: this.autoRate.memo,
        sellerMemo: this.autoRate.sellerMemo,
        sellerFlag: this.autoRate.sellerFlag,
        delay: this.autoRate.delay,
        rateType: this.autoRate.rateType,
        attack: this.autoRate.attack,
        rateAttack: this.autoRate.rateAttack,
        rateBlack: this.autoRate.rateBlack,
        blackId: this.autoRate.blackId,
        blackBuyer: this.autoRate.blackBuyer
        //moban: this.mbstr,
        //rateMoban: this.autoRate.rateMoban
      }

      $api.post("/auto/addAuto", param, response =>{
        let dataResult = response.data;
        if (dataResult.state == 1 && dataResult.message == "ok") {
          this.$message({
            type: 'success',
            message: '自动备注设置成功！'
          })
        }else {
          this.$message.error(dataResult);
        }
      })
    },
    getRateUser(){
      let param = {
        nick: storage.get("nick")
      }
      $api.post("/auto/getAuto", param, response => {
        let dataResult = response.data;
        if (dataResult.state == 1 && dataResult.message == "ok") {
          console.log(dataResult);
          if(dataResult.data.auto != null){
            this.autoRate = dataResult.data.auto;
          }else{
            this.autoRate.nick = storage.get("nick");
          }
          console.log("success");
        }else {
          this.$message.error(dataResult);
        }
      })
    },
    getOpenIds(){
      let param = {
        nick: storage.get("nick"),
        buyers: this.buyers
      }
      $api.post("/auto/openId", param, response =>{
        let dataResult = response.data;
        console.log(response);
        if(dataResult.state == 1){
          this.openIds = dataResult.data;
        }
      })
    },
    getVersion:function(){
      let param={
        nick:storage.get("nick")
      }
      $api.post("/getVersion", param,response=>{
        let dataResult = response.data;
        if(dataResult.state=="1" && dataResult.message == "ok"){
          this.version = dataResult.data;
        }else{
          console.log(dataResult.message);
        }
      })
    },
  } ,
  mounted() {
    this.getRateUser();
    this.getVersion();

  }

}
</script>

<style scoped>
.main {
  background-color: #FFF;
  min-height: 400px;
  margin: 0px auto 0;
  border-radius: 10px;
  text-align: left;
  padding-left: 20px;
  padding-top: 10px;
}
.tb{
  width:100%;
  border-collapse: collapse;
  font-size: 12pt;
}
.tb th：{background-color: gray}

.tb tr th, .tb tr td { border:1px solid #409EFF; }

.tb td, .tb th{ height: 70px}

.btndiv{
  height: 80px;
  margin-top: 20px;
  padding-left: 200px;
}

</style>




// WEBPACK FOOTER //
// src/auto/AutoMemo.vue